import React from "react";
import {
  Text,
  View,
  ScrollView,
  TouchableOpacity,
} from "react-native";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import { Helmet } from "react-helmet";
import validate from "validate.js";
import CryptoJS from "crypto-js";

import { enUS } from './en-US.js';
import { zhHK } from './zh-HK.js';
import { host, api11, api13, busiSecKey } from './../../config/api';
import { formStyles } from './../../config/styles';
import { clearEmptyStrings, hmacSha256, msgCodeDetail } from './../../lib/utils';
import { memberStorage } from './../../lib/MemberStorage';
import { languageStorage } from './../../lib/LanguageStorage';
import Locale from './../../Locale';
import Member from './../../Member';
import TextInput from './../../components/TextField/TextField';
import Alert from './../../components/Alert/Alert';
import Navbar from './../../components/Navbar/Navbar';
import Footer from './../../components/Footer/Footer';
import ModalOTP from "../../components/ModalOTP/ModalOTP.js";
import YesNoRadio from "../../components/YesNoRadio/YesNoRadio.js";

const SKIP_OTP_HEADER = "X-SKIP-OTP";
const SKIP_OTP_NAME = "skipOtpToken";

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: {},
      messages: {},
      isUseSMS:"Y" // "Y" || "N"
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    const getText = (language) => {
      let text = enUS;
      if (language == "zhHK") {
        text = zhHK;
      }
      return text;
    };
    languageStorage.getLanguage((language) =>
      this.setState({
        language: language,
        text: getText(language),
      })
    );
  }

  showError(text) {
    this.setState({
      alert: Alert.alert(this.state.text.alert, text || "Some Error happen" , [
        {
          text: this.state.text.ok,
          onPress: () => {
            this.setState({ alert: null });
          },
        },
      ]),
    });
  }

  async _checkPasswordVerify() {
    const data = JSON.stringify({
      username: this.state.mobileNumber,
      password: this.state.password,
      timeStamp: Date.now(),
    });

    const hmac = hmacSha256(data);

    try {
      const response = await fetch(host + "/member/password/verify", {
        method: "POST",
        credentials: 'include',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
          [SKIP_OTP_HEADER]: localStorage.getItem(SKIP_OTP_NAME)
        },
        body: "data=" + encodeURIComponent(data) + "&hmac=" + hmac + "&countFailure=1",
      });

      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return false;
    }
  }

  async _sendShortMessage(isSendEmail) {
    const data = JSON.stringify({
      mobile: this.state.mobileNumber,
      isSendEmail: isSendEmail ? "Y" : "N",
      timeStamp: Date.now(),
    });

    const hmac = hmacSha256(data);

    try {
      const response = await fetch(host + api11, {
        method: "POST",
        credentials: 'include',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "data=" + encodeURIComponent(data) + "&hmac=" + hmac,
      });
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return false;
    }
  }

  async _clickLoginButton() {
    const state = clearEmptyStrings(this.state);

    let attributes = {
      mobileNumber: this.state.mobileNumber,
      password: this.state.password,
    };

    let constraints = {
      mobileNumber: {
        presence: { message: this.state.text.thisFieldCannotBeBlank },
        numericality: { message: this.state.text.invalidMobileNumber },
        length: { is: 8, message: this.state.text.invalidMobileNumber },
      },
      password: {
        presence: { allowEmpty: false, message: this.state.text.passwordCannotBeBlank },
      },
    };

    const messages = validate(attributes, constraints, { fullMessages: false });

    if (messages) {
      this.setState({ messages: messages });
      return;
    }

    if (this.state.shortMessageSending) {
      return;
    }

    this.setState({
      messages: {},
      shortMessageSending: true,
      shortMessageSent: false,
    });

    // check password is correct
    const checkPasswordVerifyRes = await this._checkPasswordVerify();
    if (checkPasswordVerifyRes.msgCode !== 0) {
      this.setState({ shortMessageSending: false });
      this.showError(
        msgCodeDetail(checkPasswordVerifyRes.msgCode)[
          this.state.language === "enUS" ? "desc_en" : "desc_zh"
      ]);
      return;
    }

    // check need to send OTP or direct login
    if (checkPasswordVerifyRes.msgDesc?.token) {
      this._handleLoginedMember(checkPasswordVerifyRes.msgDesc);
    } else {
      const sendShortMessageRes = await this._sendShortMessage(this.state.isUseSMS === "N");
      if (sendShortMessageRes.msgCode === 0) {
        this.setState({
          targetPhoneNumber: this.state.mobileNumber,
          shortMessageSent: true,
        });
      } else {
        this.showError(
          msgCodeDetail(sendShortMessageRes.msgCode)[
            this.state.language === "enUS" ? "desc_en" : "desc_zh"
          ]
        );
      }
    }
    this.setState({ shortMessageSending: false });
  }

  divider(style) {
    return (
      <div style={style.orStyle}>
        <div style={style.horizontalLine}></div>
        <div style={{ flex: 1 }}>
          <span>{this.state.text.or}</span>
        </div>
        <div style={style.horizontalLine}></div>
      </div>
    );
  }

  _handleLoginedMember(msgDesc) {
    const { member, theme, token } = msgDesc;
    if (this.state.mobileNumber === member.mobile.toString()) {
      Object.assign(member, { theme });
      console.log(`member ${member}`);
      memberStorage.setMember(member, token, () => {
        Member.load().then((member) => (Member._member = member));
        this.setState({
          alert: Alert.alert(
            this.state.text.welcome,
            this.state.text.loggedIn,
            [
              {
                text: this.state.text.ok,
                onPress: () => {
                  if (
                    this.props.history.location.state &&
                    this.props.history.location.state.from &&
                    this.props.history.location.state.from ===
                      "PrivilegedClubList"
                  ) {
                    this.props.history.push("/privilegedClubList");
                  } else {
                    this.props.history.push("/");
                  }
                },
                //onPress: () => this.props.history.push("/privilegedClubList")
              },
            ]
          ),
        });
      });
    } else {
      this.showError(this.state.text.loginFailed);
      this.setState({ loggingIn: false });
    }
  }

  async _login(otpCode, isSaveDevice) {
    if (this.state.loggingIn || !otpCode) {
      return;
    }
    this.setState({ loggingIn: true });
    const data = JSON.stringify({
      username: this.state.mobileNumber,
      password: this.state.password,
      verify_code: otpCode,
      timeStamp: Date.now(),
      skip_otp: isSaveDevice ? "1" : "0",
    });

    try {
      const key = CryptoJS.AES.decrypt(
        busiSecKey,
        "ACTj4a4589rxPEIW2PoE"
      ).toString(CryptoJS.enc.Utf8);

      const hmac = hmacSha256(data);

      const response = await fetch(host + api13, {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "data=" + encodeURIComponent(data) + "&hmac=" + hmac,
      });

      const responseJson = await response.json();
      const hmacHex =
        responseJson.msgDesc?.member &&
        CryptoJS.enc.Hex.stringify(
          CryptoJS.HmacSHA256(
            `${responseJson.msgDesc.member.id}-${responseJson.msgDesc.member.firstName}-${responseJson.msgDesc.member.lastName}-${responseJson.msgDesc.member.email}-${responseJson.msgDesc.member.mobile}-${responseJson.msgDesc.timeStamp}`,
            key
          )
        );

      if (responseJson.msgCode === 0 && hmacHex === responseJson.msgDesc.hmac) {
        console.log(`RESPONSE JSON ${responseJson.msgCode}`);
        this._handleLoginedMember(responseJson.msgDesc);

        // save skip OTP token in localstage
        const headers = response.headers;
        const skipOtpToken = headers.get(SKIP_OTP_HEADER);
        localStorage.setItem(SKIP_OTP_NAME, skipOtpToken);
      } else if (responseJson.msgCode === 20) {
        this.setState({
          alert: Alert.alert(
            this.state.text.alert,
            this.state.text.pleaseRegisterFirst,
            [
              {
                text: this.state.text.register,
                onPress: () => this.props.history.push("/register"),
              },
            ],
            { cancelable: false }
          ),
        });
      } else if (responseJson.msgCode) {
        this.showError(
          msgCodeDetail(responseJson.msgCode)[
            this.state.language === "enUS" ? "desc_en" : "desc_zh"
          ]
        );
      } else {
        this.showError(
          this.state.text.loginFailed + "Message code: " + responseJson.msgCode
        );
      }
    } catch (error) {
      this.showError(this.state.text.loginError + error);
    } finally {
      this.setState({ loggingIn: false });
    }
  }

  render() {
    return (
      <div className="App">
        <Helmet>
          <title>Login | Bravo Generali</title>
        </Helmet>

        <Navbar
          title={this.state.text.login}
          backButton
          history={this.props.history}
        />
        <Grid container spacing={20} style={{ backgroundColor: "#f2f2f2" }}>
          <Hidden xsDown>
            <Grid
              item
              xs
              style={{ marginBottom: 13, marginLeft: "5%", marginRight: "5%" }}
            >
              <View style={[styles.greeting, { fontWeight: "bold" }]}>
                <Text
                  style={[
                    styles.greetingText,
                    { marginTop: "10%", fontSize: 35 },
                  ]}
                >
                  {this.state.text.login}
                </Text>
                <p></p>
                <Text style={[styles.greetingText, { fontSize: 20 }]}>
                  {this.state.text.back}
                </Text>
              </View>
            </Grid>
          </Hidden>

          <Grid
            item
            xs
            style={{
              marginTop: 30,
              marginBottom: 50,
              backgroundColor: "white",
            }}
          >
            <ScrollView style={[formStyles.form, styles.fieldset]}>
              {this.state.alert}
                <View style={[formStyles.fieldset]}>
                  <Text style={formStyles.h3}>
                    {Locale.text.loginWithMobilePhone}
                  </Text>
                </View>
                <form>
                <View style={[formStyles.fieldset]}>
                  <Text style={formStyles.h4}>
                    {this.state.text.mobileNumber}
                  </Text>
                  <TextInput
                    style={formStyles.input}
                    onChangeText={(text) => this.setState({ mobileNumber: text })}
                    value={this.state.mobileNumber}
                    keyboardType="numeric"
                    autoComplete
                    name="username"
                  />
                  <Text style={formStyles.message}>
                    {this.state.messages.mobileNumber}
                  </Text>
                </View>

                <View style={[formStyles.fieldset]}>
                  <Text style={formStyles.h4}>{this.state.text.password}</Text>
                  <TextInput
                    style={formStyles.input}
                    onChangeText={(text) => this.setState({ password: text })}
                    value={this.state.password}
                    keyboardType="password"
                    autoComplete
                    name="password"
                  />
                  <Text style={formStyles.message}>
                    {this.state.messages.password}
                  </Text>
                </View>
              </form>
              <View style={formStyles.fieldset}>
                <YesNoRadio
                  choice={this.state.isUseSMS}
                  question={this.state.text.otpMethod}
                  questionStyle={{marginTop:"10px"}}
                  onChange={(v)=>this.setState({isUseSMS:v})}
                  noLabel={this.state.text.email}
                  yesLabel="SMS"
                />
              </View>

              {!this.state.shortMessageSent && (
                <View style={[formStyles.fieldset, styles.fieldset]}>
                  {this.state.shortMessageSending ? (
                    <View style={{ marginTop: "1em" }}>
                      <View style={[formStyles.submitButtonDisabled]}>
                        <Text style={formStyles.submitButtonText}>
                          {this.state.text.pleaseWait}
                        </Text>
                      </View>
                    </View>
                  ) : (
                    <View style={{ marginTop: "1em" }}>
                      <TouchableOpacity
                        style={formStyles.submitButton}
                        onPress={() => this._clickLoginButton()}
                      >
                        <Text style={formStyles.submitButtonText}>{this.state.text.login}</Text>
                      </TouchableOpacity>
                      {this.divider(styles)}
                      <TouchableOpacity
                        style={formStyles.textButton}
                        onPress={() => {
                          if (this.props.history.location.state && this.props.history.location.state.from && this.props.history.location.state.from === 'PrivilegedClubList') {
                            this.props.history.push("/register", { from: 'PrivilegedClubList' })
                          } else {
                            this.props.history.push("/register")
                          }
                        }}
                      >
                        <Text style={formStyles.textButtonText}>
                          {this.state.text.register}
                        </Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={formStyles.textButton}
                        onPress={() => {
                          this.props.history.push("/forgot-password");
                        }}
                      >
                        <Text style={formStyles.textButtonText}>
                          {this.state.text.forgotOrNoPassword}
                        </Text>
                      </TouchableOpacity>
                    </View>
                  )}
                </View>
              )}
            </ScrollView>
          </Grid>
          <Hidden xsDown>
            <div style={{ marginRight: "5%" }} />
          </Hidden>
        </Grid>
        <Footer />
        <ModalOTP
          open={this.state.shortMessageSent}
          onClose={() => this.setState({ shortMessageSent: false })}
          onSubmit={(optCode, isSaveDevice) => this._login(optCode, isSaveDevice)}
          onResend={(bool)=>this._sendShortMessage(bool)}
          canSave
        />
      </div>
    );
  }
}

const styles = {
  orStyle: {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    fontSize: "14px",
    color: "grey",
    alignItems: "center",
    marginBottom: 10,
    marginTop: 10
  },
  horizontalLine: {
    width: "100%",
    height: "1px",
    backgroundColor: "grey",
    flex: 1,
  },
  container: {
    flex: 1,
    alignItems: "stretch",
  },
  form: {
    minHeight: 500,
    paddingTop: 100,
  },
  fieldset: {
    margin: "auto",
    minWidth: 300,
    maxWidth: 600,
    minHeight: 620,
  },
  link: {
    color: "#C50000",
  },
};
